import React, { createContext, useContext, useState, useEffect } from 'react';

const PageLanguageContext = createContext();

export const PageLanguageProvider = ({ children }) => {
  const [pageLanguage, setPageLanguage] = useState(() => {
    return localStorage.getItem('page-language') || 'en';
  });

  useEffect(() => {
    localStorage.setItem('page-language', pageLanguage);
  }, [pageLanguage]);

  return (
    <PageLanguageContext.Provider value={{ pageLanguage, setPageLanguage }}>
      {children}
    </PageLanguageContext.Provider>
  );
};

export const usePageLanguage = () => {
  const context = useContext(PageLanguageContext);
  if (!context) {
    throw new Error('usePageLanguage must be used within a PageLanguageProvider');
  }
  return context;
};
